import { Component, Input, ViewChild } from '@angular/core';
import { GaEventTrackerProvider } from '../../../services/gaeventtracker.provider';

@Component({
  selector: 'app-audioplayer',
  templateUrl: 'audioplayer.html',
  styleUrls: ['audioplayer.scss'],
})
export class AudioplayerComponent {
  @Input() public audiofile: string;
  @Input() public newspaper: string;
  @Input() public slug: string;
  @Input() public category: string;
  @ViewChild('audiolayer') audio;
  @ViewChild('progress') progress;
  @ViewChild('dot') dot;
  public playing = false;

  constructor(private gaService: GaEventTrackerProvider) {}

  updateProgress() {
    this.progress.nativeElement.value =
      this.audio.nativeElement.currentTime / this.audio.nativeElement.duration;
    const pase =
      this.progress.nativeElement.offsetWidth /
      this.audio.nativeElement.duration;
    this.dot.nativeElement.style.left =
      this.progress.nativeElement.offsetLeft -
      1 +
      pase * this.audio.nativeElement.currentTime +
      'px';
  }

  play() {
    if (!this.playing) {
      this.audio.nativeElement.play();
      this.playing = true;
      this.gaService.sendAudioArticle(this.newspaper, this.category, this.slug);
    } else {
      this.audio.nativeElement.pause();
      this.playing = false;
    }
  }

  decreaseVolume() {
    if (!(this.audio.nativeElement.volume <= 0.1)) {
      this.audio.nativeElement.volume = this.audio.nativeElement.volume - 0.1;
    }
  }

  increaseVolume() {
    if (!(this.audio.nativeElement.volume >= 0.9)) {
      this.audio.nativeElement.volume = this.audio.nativeElement.volume + 0.1;
    }
  }

  jump(e) {
    const percent = (e.pageX - this.progress.nativeElement.offsetLeft) / this.progress.nativeElement.offsetWidth; //Get width element
    this.audio.nativeElement.currentTime = percent * this.audio.nativeElement.duration;
  }

  setPlayButton() {
    this.playing = false;
  }
}
